import ahoy from "ahoy.js"
import { acceptedCategory } from "vanilla-cookieconsent"

// ahoy.js auto-starts visit tracking on DOMContentLoaded by default. Previously
// that was gated by the browser never executing this script at all until
// analytics consent was given (a vanilla-cookieconsent data-category script
// tag). Now that this ships as a normal bundled pack, gate it here instead.
ahoy.configure({ startOnReady: false })

// Exposed so other packs (e.g. business_update_tracking_controller.js) can
// fire one-off events for anonymous visitors without importing ahoy.js a
// second time.
window.ahoy = ahoy

// ahoy.start() is self-guarding: the first call creates the visit and
// reassigns itself to a no-op (see ahoy.js's own source), so calling it
// again from a later event - e.g. a user flipping analytics on via
// preferences after already accepting once - is a harmless no-op, not a
// duplicate visit.
function startIfConsented() {
  if (acceptedCategory("analytics")) ahoy.start()
}

// Fires on the very first consent action and on every subsequent page load,
// so this alone covers both "already consented" and "just consented" - no
// need for an immediate call here.
window.addEventListener("cc:onConsent", startIfConsented)
window.addEventListener("cc:onChange", startIfConsented)
